import React from 'react';

import { BASE_COLOR } from 'shared/constants/colors';


/*
 * HorizontalRule
 */
const HorizontalRule = ({
  className = '',
  color = BASE_COLOR.lightGray,
  thickness = '1px',
  width = '100%',
  align = 'center',  // center|left|right
}) => {
  const margin = {
    marginLeft: (align === 'left' ? 0 : null),
    marginRight: (align === 'right' ? 0 : null),
  };

  return (
    <hr className={className} style={{
      width: width,
      borderWidth: thickness,
      borderColor: color,
      borderStyle: 'solid',
      ...margin
    }} />
  );
};



export {
  HorizontalRule,
};



// WEBPACK FOOTER //
// ./src/components/elems/HorizontalRule.js